export const ER_TG_USER_ERROR = 'ER_TG_USER_ERROR';
export const ER_USER_ERROR = 'ER_USER_ERROR';
